// externals
import type { Reducer } from 'redux';

// libraries
import type { SharedBootstrapState } from '@makemydeal/dr-shared-types';
import { BootstrapLoadingState } from '@makemydeal/dr-shared-types';

// consts/enums
import * as bootstrapActionTypes from '../actionTypes/bootstrapActionTypes';
import { APPLICATION_LOAD_ERROR } from '../actionTypes/applicationLoadErrorActionTypes';
import { INIT_PENCIL_SUCCESS, INIT_PENCIL_INVALID_DEAL } from '../actionTypes/initActionTypes';

// interfaces/types
import type {
    AllSharedInitAppActions,
    BootstrapAppLoadErrorAction,
    BootstrapFailureAction
} from '../actions/bootstrapSharedActionCreators';

const { BOOTSTRAP_REQUEST, BOOTSTRAP_FAILURE } = bootstrapActionTypes;

export const BOOTSTRAP_INITIAL_STATE: SharedBootstrapState = {
    appStartTime: null,
    loadingState: BootstrapLoadingState.Loading,
    sessionId: null
};

export const reducer: Reducer<SharedBootstrapState> = (
    state: SharedBootstrapState = BOOTSTRAP_INITIAL_STATE,
    action: AllSharedInitAppActions
) => {
    switch (action.type) {
        case APPLICATION_LOAD_ERROR: {
            const actionTyped = action as BootstrapAppLoadErrorAction;
            return {
                ...state,
                loadingState: BootstrapLoadingState.LoadFailed,
                loadingErrorMessage: actionTyped.payload?.message || '',
                meta: null
            };
        }
        case BOOTSTRAP_REQUEST: {
            return { ...state, appStartTime: new Date(), meta: null, lazyInitCompleted: false };
        }
        case BOOTSTRAP_FAILURE: {
            const actionTyped = action as BootstrapFailureAction;
            const responsePayload = action.payload as any;
            const error = responsePayload?.response?.error?.errors?.[0]?.details?.error;
            const errorMessage = typeof error === 'string' ? error : error?.message ?? responsePayload?.response?.message;

            return {
                ...state,
                loadingState: BootstrapLoadingState.LoadFailed,
                meta: {
                    ...actionTyped.meta,
                    responseErrorMessage: errorMessage
                }
            };
        }
        case INIT_PENCIL_SUCCESS:
        case INIT_PENCIL_INVALID_DEAL: {
            return {
                ...state,
                loadingState: BootstrapLoadingState.LoadedSuccessfully,
                meta: null
            };
        }
        default: {
            return state;
        }
    }
};
